import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

export interface MessageInfo {
  title?: string;
  detail?: string;
}

@Injectable({ providedIn: 'root' })
export class GlobalMessageService {
  private errorSubject = new Subject<MessageInfo | undefined>();

  constructor(private messageService: MessageService) {
    this.errorSubject
      .pipe(throttleTime(2000))
      .subscribe((data: MessageInfo | undefined) => {
        messageService.add({
          severity: 'error',
          summary: data?.title || 'Error',
          detail: data?.detail || 'Something went wrong',
          life: 2000,
        });
      });
  }

  showErrorMessage(data?: MessageInfo): void {
    this.errorSubject.next(data);
  }

  showInfoMessage(data?: MessageInfo): void {
    this.messageService.add({
      severity: 'info',
      summary: data?.title || 'Info',
      detail: data?.detail || '',
      life: 2000,
    });
  }

  showWarningMessage(data?: MessageInfo): void {
    this.messageService.add({
      severity: 'warn',
      summary: data?.title || 'Warning',
      detail: data?.detail || '',
      life: 2000,
    });
  }

  showSuccessMessage(data?: MessageInfo): void {
    this.messageService.add({
      severity: 'success',
      summary: data?.title || 'Success',
      detail: data?.detail || '',
      life: 2000,
    });
  }
}
